import React, { Component } from "react";
import { Modal, Row, Col, Button, ListGroup, Form, InputGroup  } from "react-bootstrap";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { LinkContainer } from "react-router-bootstrap";
import "containers/common/List.css";
import { API } from "aws-amplify";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import SLMAgencyModal from "containers/slm/SLMAgencyModal"; //new
import Amplify, { Auth } from "aws-amplify";
//import Moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default class SLMOwnerLinkList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            agencies: [],
            filter: {},
            showAgentDialog: false,
            showAlert: false,
            editedAgencies: [],
            dataSet: "ownerLinks",
            dataRecord: "ownerLink",
            dataSetPrimaryKey: "owner_link_id",
            newRecordIndex: 0,
            ownerSearchString: null,
            ownerInterstateFlag: true,
            selectedOwner: null,
            selectedContact: null,
            ownerOptions: [], 
            contactOptions: [],
            ownerMenuIsOpen: false,
            owner_org_id: null,
            owner_name: null,
            owner_phone: null,
            owner_phone_ext: null,
            owner_phone_no: null,
            owner_suburb: null,
            owner_state: null,
            owner_postcode: null,
            owner_person_id: null,
            contact_phone: null,
            contact_email: null,
            typeOptions:[{value: 2, label: 'Buyer'},{value: 3, label: 'Vendor'}],
            leaseTypeOptions:[{value: 0, label: 'Lessee'},{value: 1, label: 'Lessor'}],
            tableRows: this.props.data.length

        };

        this.toggleAgentModal = this.toggleAgentModal.bind(this);
        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
        console.log("In SLMOwnerLinkList componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }


       
        //if (this.props.passBackMainAddress) {
            
        //    if (this.state.addresses.length > 0) {
        //        this.props.buildAddress(this.state.addresses[0]);
        //    }
        //};

        this.setState({ isLoading: false });      
    }

    async componentDidUpdate(prevProps) {
        console.log("ComponentDidUpdate");


       
    }

    //async componentDidUpdate(prevProps) {

    //    if (this.props.passBackMainAddress != prevProps.passBackMainAddress ) {
    //      if (this.state.addresses.length > 0) {
    //            var i;
    //          for (i = 0; i < this.state.addresses.length; i++) {
    //            if (this.state.addresses[i].main_address === true) {
    //                    this.props.buildAddress(this.state.addresses[i]);
    //                    return;
    //              }
      
    //           }
                
    //        }
    //        this.props.buildAddress({});
    //    };
       
//}



 

    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }

   

    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete owner link");
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
                this.props.updateVendorFields();
            }
            )
        };
    };


    handleInputChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleSave = async () => {
    
        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }  
        
        

        this.props.updateTableState(data, this.state.dataSet);

    }

    handleEditRecord  = async (cellInfo, event)=> {
        console.log(cellInfo);
        const contactOptions = await this.props.getContacts({ orgid: cellInfo.original.owner_org_id });
        this.setState({
            showAgentDialog: !this.state.showAgentDialog,
            newRecordIndex: cellInfo.index
            ,selectedContact: { value: cellInfo.original.owner_person_id, label: cellInfo.original.contact_name }  
            ,selectedOwner: { value: cellInfo.original.owner_org_id, label: cellInfo.original.name }     
            ,selectedType : { value: cellInfo.original.type_cat_id, label: cellInfo.original.type }           
            ,type: cellInfo.original.type
            ,owner_name: cellInfo.original.name
            ,owner_link_id: cellInfo.original.owner_link_id
            ,owner_org_id: cellInfo.original.owner_org_id
            ,owner_phone: (cellInfo.original.phone_ext||"")+" "+(cellInfo.original.phone_no||" ")
            ,owner_phone_ext: cellInfo.original.phone_ext
            ,owner_phone_no: cellInfo.original.phone_no
            ,owner_suburb: cellInfo.original.mail_suburb
            ,owner_state: cellInfo.original.mail_state
            ,owner_postcode: cellInfo.original.mail_code
            ,owner_person_id: cellInfo.original.owner_person_id
            ,contact_phone: cellInfo.original.contact_phone
            ,contact_email: cellInfo.original.contact_email   
            ,contactOptions: contactOptions
        });
        console.log(cellInfo);

    }

    addRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({

            owner_org_id: null ,
            owner_person_id: null  ,
            sale_id: this.props.sale_id? this.props.sale_id: null,
            lease_id: this.props.lease_id? this.props.lease_id: null,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            selectedType: this.props.sale_id?{value: 2, label: 'Buyer'}: {value: 0, label: 'Lessee'},
            type_cat_id: this.props.sale_id?2:0,
            type: this.props.sale_id?"Buyer":"Lessee",
            new_record: true            
        });

        this.setState({
            showAgentDialog: !this.state.showAgentDialog,
            newRecordIndex: data.length-1,
            selectedType: this.props.sale_id?{value: 2, label: 'Buyer'}: {value: 0, label: 'Lessee'}
        });
        this.props.updateTableState(data, this.state.dataSet);
        
    }

    addAnotherRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({

            entity_org_id: null ,
            entity_person_id: null  ,
            sale_id: this.props.sale_id? this.props.sale_id: null,
            lease_id: this.props.lease_id? this.props.lease_id: null,
            type_cat_id: this.props.sale_id?2:0,
            type: this.props.sale_id?"Buyer":"Lesee",
            name: null ,
            phone_no: "" ,            
            phone_ext: "" ,            
            mail_suburb: "" ,
            mail_state: "" ,
            mail_code: "" ,
            contact_name: "" ,
            contact_phone: ""  ,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true            
        });

        this.setState({    
            selectedOwner: {value: null, label: null},
            selectedContact: {value: null, label: null},
            selectedType: this.props.sale_id?{value: 2, label: 'Buyer'}: {value: 0, label: 'Lessee'},
            name: null ,
            phone_no: "" ,            
            phone_ext: "" ,            
            owner_suburb: "" ,
            owner_state: "" ,
            owner_postcode: "" ,
            owner_phone: "",
            owner_email: "",

            contact_name: "" ,
            contact_phone: ""  ,     
            contact_email: ""  ,       
            newRecordIndex: data.length-1
        });
        this.props.updateTableState(data, this.state.dataSet);
        this.setState({data});
    }

    addContactRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({
            owner_org_id: this.state.owner_org_id ,
            owner_person_id: null  ,
            sale_id: this.props.sale_id? this.props.sale_id: null,   
            lease_id: this.props.lease_id? this.props.lease_id: null,         
            type_cat_id: this.state.selectedType.value,   
            type: this.state.selectedType.label,  
            name: this.state.owner_name ,
            phone_no: this.state.owner_phone_no ,            
            phone_ext: this.state.owner_phone_ext ,            
            mail_suburb: this.state.owner_suburb ,
            mail_state: this.state.owner_state ,
            mail_code: this.state.owner_postcode ,
            contact_name: null ,
            contact_phone: null  ,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true            
        });

        this.setState({
                        owner_person_id: null,
                        contact_phone: "",
                        contact_email: "",
                        newRecordIndex: data.length-1,
                        selectedContact: {label: null, value: null},
                    
                    });
        this.props.updateTableState(data, this.state.dataSet);
        this.setState({data});
    }



    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

            case "number":
                return (
                    <input
                        onChange={this.handleInputChange.bind(null, cellInfo)}
                        onBlur={this.handleSave.bind(null, cellInfo)}
                        type="number"
                        className="no-border form-control"
                        value={cellValue}

                    />
                );

            default:
                if (cellInfo.column.id.indexOf("date") >= 0) {
                    return (
                        <DatePicker
                            selected={new Date(cellValue)}
                            onChange={this.handleDateChange.bind(null, cellInfo)}
                            onBlur={this.handleSave.bind(null, cellInfo)}
                            dateFormat="dd/MM/yyyy"
                        />);
                }
                else if (cellInfo.column.id === "name" && cellValue === "") {
                    return (
                        <Select
                            value={cellValue} //UPDATE
                            onChange={this.handleagencyChange} //UPDATE
                            options={this.props.ownerOptions}

                        />);
                }
                else {
                    return (
                        <input
                            onChange={this.handleInputChange.bind(null, cellInfo)}
                            onBlur={this.handleSave.bind(null, cellInfo)}
                            type="text"
                            className="no-border form-control"
                            value={cellValue}

                        />
                    );
                }

        }
    }

    


    renderTable(data) {
        const columns = [

            {
                id: 'owner_org_id',
                Header: 'Agency ID',
                accessor: 'owner_org_id',
                Cell: e => <LinkContainer to={`../slmagency/${e.value}`}><a> {e.value} </a></LinkContainer>
            },
             
            {
                id: 'name',
                Header: 'Agency',
                accessor: 'name',
                Cell: this.renderEditable
                

            },{
                id: 'mail_street',
                Header: 'Street',
                accessor: 'mail_street',
                Cell: this.renderEditable


            },
            {
                id: 'mail_suburb',
                Header: 'Suburb',
                accessor: 'mail_suburb',
                Cell: this.renderEditable

            },
            {
                id: 'mail_state',
                Header: 'State',
                accessor: 'mail_state',
                Cell: this.renderEditable

            },
            {
                id: 'mail_code',
                Header: 'Postcode',
                accessor: 'mail_code',
                Cell: this.renderEditable

            },
            {
                id: 'phone_ext',
                Header: 'Phone Ext',
                accessor: 'phone_ext',
                Cell: this.renderEditable

            },
            {
                id: 'phone_no',
                Header: 'Phone No',
                accessor: 'phone_no',
                Cell: this.renderEditable

            },
            {
                id: 'email',
                Header: 'Email',
                accessor: 'email',
                Cell: this.renderEditable

            },
            {
                id: 'web',
                Header: 'Web',
                accessor: 'web',
                Cell: this.renderEditable

            }
            ,
            {
                id: 'notes',
                Header: 'Notes',
                accessor: 'notes',
                Cell: this.renderEditable

            },{
                Header: '',
                accessor: 'owner_org_id',
                Cell: row => <button onClick={(e) => this.handleDeleteRecord(row.value,e)}>Delete</button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }

    }




    toggleAgentModal = async () => {
        this.setState(state => ({
            showAgentDialog: !this.state.showAgentDialog,
            ownerSearchString: "",
            ownerInterstateFlag: true,
            selectedOwner: null,
            selectedContact: null,  
            selectedType: null,
            ownerMenuIsOpen: false,
            owner_org_id: null,
            owner_phone: "",
            owner_suburb: "",
            owner_state: "",
            owner_postcode: "",
            owner_person_id: null,
            contact_phone: "",
            contact_email: ""
        }));
        

        let data = [...this.props.data];
        
        
        if (data[0].hasOwnProperty("type_cat_id")) {
            data.sort(function (a, b) { return a.type_cat_id - b.type_cat_id });
        }

        if (data[0].hasOwnProperty("owner_name")) {
            data.sort(function (a, b) { 
                if(a.owner_name < b.owner_name) { return -1; }
                if(a.owner_name > b.owner_name) { return 1; }
                return 0;
             });
        }
        var i;
        for(i=0;i<data.length;i++){
            if (!data[i].owner_link_id){
                data.splice(i, 1);
            }
        }
        this.props.updateVendorFields();
        this.props.updateTableState(data, this.state.dataSet);
        this.setState({tableRows: this.props.data.length+1});
    }

    handleOwnerSearch = async () => {
        try {
           
            let state = null;
            if (!this.state.ownerInterstateFlag) {
                    state = this.props.state_code;
            }
            const ownerOptions = await this.props.getOwners({ ownername: this.state.ownerSearchString,state: state });
            console.log(ownerOptions);
            this.setState({ ownerMenuIsOpen: true, ownerOptions: ownerOptions});
        }
        catch{
            alert("Error loading proposals");
        }
    }

    handleEnterOnSearch = (e) => {
        if (e.keyCode === 13) {
            this.handleOwnerSearch();

        }
    }

    handleFormInputChange = event => {
        this.setState({ [event.target.id]: event.target.value });

    }

    handleCheckBoxChange = event => {
        
        let name = event.target.name
        this.setState({
            [name]: event.target.checked
             })
    }

    handleOwnerChange = async (selectedOwner) => {
        
        let data = [...this.props.data];
        data[this.state.newRecordIndex].modified = true;
        
        if(selectedOwner){
                const contactOptions = await this.props.getContacts({ orgid: selectedOwner.value });
                this.setState({ ownerMenuIsOpen: false
                        ,selectedOwner:  selectedOwner
                        ,contactOptions: contactOptions
                        , modified: true
                        ,selectedContact: { value: null, label: null }            
                        ,owner_name: selectedOwner.name
                        ,owner_org_id: selectedOwner.value
                        ,owner_phone: (selectedOwner.phone_ext||"")+" "+(selectedOwner.phone_no||" ")
                        ,owner_phone_ext: selectedOwner.phone_ext
                        ,owner_phone_no: selectedOwner.phone_no
                        ,owner_suburb: selectedOwner.mail_suburb
                        ,owner_state: selectedOwner.mail_state
                        ,owner_postcode: selectedOwner.mail_code
                        ,owner_person_id: null
                        ,contact_phone: ""
                        ,contact_email: ""   
                    }); 
                    data[this.state.newRecordIndex].owner_org_id = selectedOwner.owner_org_id;     
                    data[this.state.newRecordIndex].name = selectedOwner.name ;
                    data[this.state.newRecordIndex].owner_name = selectedOwner.name ;
                    data[this.state.newRecordIndex].phone_ext = selectedOwner.phone_ext ;
                    data[this.state.newRecordIndex].phone_no = selectedOwner.phone_no; 
                    data[this.state.newRecordIndex].mail_suburb = selectedOwner.mail_suburb ;
                    data[this.state.newRecordIndex].mail_state = selectedOwner.mail_state ;
                    data[this.state.newRecordIndex].mail_code = selectedOwner.mail_code;  
                    data[this.state.newRecordIndex].contact_name = null ;
                    data[this.state.newRecordIndex].contact_phone = null  ;       
                }
            else{
                this.setState({ ownerMenuIsOpen: false
                    ,selectedOwner:  { value: null, label: null }
                    ,contactOptions: []
                    , modified: true
                    ,selectedContact: { value: null, label: null }            
                    ,owner_org_id: null
                    ,owner_name: null
                    ,owner_phone: ""
                    ,owner_phone_ext: null
                    ,owner_phone_no: null
                    ,owner_suburb: ""
                    ,owner_state: ""
                    ,owner_postcode: ""
                    ,owner_person_id: null
                    ,contact_phone: ""
                    ,contact_email: ""   
                }); 
                data[this.state.newRecordIndex].entity_org_id = null ;
                data[this.state.newRecordIndex].name = null ;
                data[this.state.newRecordIndex].phone_ext = null ;
                data[this.state.newRecordIndex].phone_no = null ;
                data[this.state.newRecordIndex].mail_suburb = null ;
                data[this.state.newRecordIndex].mail_state = null ;
                data[this.state.newRecordIndex].mail_code = null ;
                data[this.state.newRecordIndex].contact_name = null ;
                data[this.state.newRecordIndex].contact_phone = null  ;
                
                ;                
            }
            const result = this.props.updateTableState(data, this.state.dataSet);
            if (result){
                this.handleSave();
            }
            this.setState({data});
            
    }


    handleCreateContactInputChange = async (selectedContact) => { 
        const contact={
                        entity_org_id: this.props.ownerorgid ,
                        owner_person_id: null  ,
                        first_name: selectedContact,
                        last_name: "",
                        position: "",
                        home_street: "",
                        home_suburb: "",
                        home_state: "",
                        home_code: "",
                        phone_ext: "",
                        phone_no: "",
                        email : "",
                        notes: "",
                        created_by: this.props.user,
                        last_edited_by: this.props.user,
                        new_record: true            
                    }
        return await this.props.saveRecord(contact, "ownerContact", "owner_person_id");
    }

    handleContactChange = async (selectedContact) => {     
        let data = [...this.props.data];
        data[this.state.newRecordIndex].modified = true;           
        if(!selectedContact){
            this.setState({ selectedContact: { value: null, label: null }  
                        , modified: true
                        ,owner_person_id: null
                        ,contact_phone: ""
                        ,contact_email: ""

            });
            data[this.state.newRecordIndex].owner_person_id = null; 
            data[this.state.newRecordIndex].contact_name = null ;
            data[this.state.newRecordIndex].contact_phone = null  ;
        }
        else{
            this.setState({ selectedContact: selectedContact
                , modified: true
                ,owner_person_id: selectedContact.value
                ,contact_phone: (selectedContact.phone_ext||"")+" "+(selectedContact.phone_no||" ")
                ,contact_email: selectedContact.email

            });
            data[this.state.newRecordIndex].owner_person_id = selectedContact.owner_person_id; 
            data[this.state.newRecordIndex].contact_name = selectedContact.label ;
            data[this.state.newRecordIndex].contact_phone =  (selectedContact.phone_ext||"")+" "+(selectedContact.phone_no||" "); 
        }
        const result = this.props.updateTableState(data, this.state.dataSet);
            if (result){
                this.handleSave();
            }
    }


    handleTypeChange = async (selectedType) => {     
        let data = [...this.props.data];
        data[this.state.newRecordIndex].modified = true;           
        if(!selectedType){
            this.setState({ selectedType: { value: null, label: null }  
                        , modified: true
                        ,type_cat_id: null
                        ,type: null                        

            });
            data[this.state.newRecordIndex].type_cat_id = null; 
            data[this.state.newRecordIndex].type = null; 
        }
        else{
            this.setState({ selectedType: selectedType
                , modified: true
                ,type_cat_id: selectedType.value
                ,type: selectedType.label

            });
            data[this.state.newRecordIndex].type_cat_id = selectedType.value;
            data[this.state.newRecordIndex].type= selectedType.label 
        }
        const result = this.props.updateTableState(data, this.state.dataSet);
            if (result){
                this.handleSave();
            }
    }



    renderTable2(data) {
        const columns = [

            {
                id: 'owner_link_id',
                Header: 'Link ID',
                maxWidth: 60,
                accessor: 'owner_link_id' ,
                Cell: row => <Button variant="link" size="sm"  onClick={(e) => this.handleEditRecord(row,e)}><div style={{"font-size": "11px"}}>{row.value}</div></Button>
            },
             
            {
                id: 'type',
                Header: 'Type',
                accessor: 'type',
                maxWidth: 65,      
                style: { 'white-space': 'unset' }               
            }
            ,
             
            {
                id: 'name',
                Header: 'Name',
                accessor: 'name',
                style: { 'white-space': 'unset' },
                Cell: row => (
                    <div><Button variant="link" size="sm" onClick={(e) =>this.handleEditRecord(row)}>{row.value}</Button> <br/>p: {row.original.phone_ext||''} {row.original.phone_no||''}<br/>e: {row.original.email}</div>
                )
            },
            // {
            //     id: 'phone_no',
            //     Header: 'Phone',        
            //     maxWidth: 120,        
            //     accessor: d=> {
            //         return (d.phone_ext||"")+" "+(d.phone_no||"")
            //     }                
            // },
            // {
            //     id: 'mail_suburb',
            //     Header: 'Suburb/State/PC',
            //     accessor: d=> {
            //         return (d.mail_suburb||"")+" "+(d.mail_state||"")+" "+(d.mail_code||"")
            //     },
            //     style: { 'white-space': 'unset' } 
            // },
            {
                id: 'contact_name',
                Header: 'Contact Name',
                accessor: 'contact_name',
                style: { 'white-space': 'unset' },
                Cell: row => (
                    <div>
                        {row.value}<br/>
                        t: {row.original.contact_phone}
                    </div>
                )
            },
            // {
            //     id: 'contact_phone',
            //     Header: 'Contact Phone',
            //     maxWidth: 120,      
            //     accessor: 'contact_phone' 
            // },
            {
                Header: '',
                accessor: 'owner_link_id',
                maxWidth: 80,
                Cell: row => <Button type="button" variant="danger" size="sm" onClick={(e) => this.handleDeleteRecord(row,e)}>Remove</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <div>
                <Modal
                    show={this.state.showAgentDialog}
                    onHide={this.toggleAgentModal}
                    dialogClassName="modal-90h"
                    //size="lg"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>{this.props.sale_id? "Buyer/Vendor": "Lessee/Lessor"}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ 'overflowX': 'scroll' }}>

                        <Form>
                        <Row>
                                <Form.Group as={Col} controlId="ownerSearchString" >
                                    <Form.Label className="text-right"  sm={6} md={6} lg={1}>Search {this.props.sale_id? "Buyer/Vendor": "Lessee/Lessor"}</Form.Label>
                               
                                        <InputGroup size="sm" >
                                            <Form.Control
                                                onChange={this.handleFormInputChange}
                                                value={this.state.ownerSearchString}
                                                onKeyDown={this.handleEnterOnSearch}
                                                as="input"
                                                type="text"
                                                placeholder="Search entities"
                                            />
                                            <InputGroup.Append><Button onClick={this.handleOwnerSearch} variant="outline-secondary" size="sm">Search</Button></InputGroup.Append>
                                        </InputGroup>
                                       
                                                <Form.Check
                                                    checked={this.state.ownerInterstateFlag}
                                                    onChange={this.handleCheckBoxChange}
                                                    label="Search interstate"
                                                    type="checkbox"
                                                    name="ownerInterstateFlag"
                                                    onBlur={this.handleBlur}
                                                    
                                                />
                                                 </Form.Group>
                                                 <Col>
                                                 <Form.Label className="text-right"  sm={6} md={6} lg={1}>{" "}</Form.Label>
                                                 <a target="_blank" rel="noopener noreferrer" href={`/slmowners/new`}><Button variant="primary" type="button" size="sm" >Create New Owner</Button></a>{" "}
                                                 {this.state.owner_org_id && 
                                                 
                                                 <a target="_blank" rel="noopener noreferrer" href={`/slmowners/${this.state.owner_org_id}`}><Button variant="primary" type="button" size="sm" >Edit Owner </Button>{" "}</a>
                                                 }
                                                 {this.state.owner_org_id && 
                                                 <Button type="button" onClick={this.addAnotherRecord} variant="primary" size="sm"> Add Another {this.props.sale_id? "Buyer/Vendor": "Lessee/Lessor"}</Button>
                                                 }
                                                 </Col>
                                                 
                    </Row>
                    <Row>
                                <Form.Group as={Col} controlId="owner_org_id" >          
                                <Form.Label className="text-right"  sm={6} md={6} lg={1}>{this.props.sale_id? "Buyer/Vendor": "Lessee/Lessor"}</Form.Label>                                
                                            <Select
                                                isClearable
                                                value={this.state.selectedOwner}
                                                onChange={this.handleOwnerChange}
                                                options={this.state.ownerOptions}
                                                onBlur={this.handleFormBlur}
                                                menuIsOpen={this.state.ownerMenuIsOpen}
                                            />                                        
                            </Form.Group>
                                <Form.Group as={Col} controlId="owner_phone" >
                                    <Form.Label  className="text-right"  sm={6} md={6} lg={1}>{this.props.sale_id? "Buyer/Vendor": "Lessee/Lessor"} Phone</Form.Label>                                    
                                        <Form.Control
                                        //onChange={this.handleFormInputChange}
                                            value={this.state.owner_phone}
                                            as="input"
                                            type="text"
                                            //onBlur={this.handleFormBlur}
                                            disabled
                                            readOnly
                                        />                                   
                                </Form.Group>
                                
                                <Form.Group as={Col} controlId="owner_locale" >
                                    <Form.Label  className="text-right"  sm={6} md={6} lg={1}>Suburb State Postcode</Form.Label>
                                   
                                        <Form.Control
                                        //onChange={this.handleFormInputChange}
                                            value={(this.state.owner_suburb||"")+" "+ (this.state.owner_state||"")+" "+(this.state.owner_postcode||"")}
                                            as="input"
                                            type="text"
                                            disabled
                                            readOnly
                                        //onBlur={this.handleFormBlur}
                                        />                                   
                                </Form.Group>
                               


                            </Row>
                            <Row>
                                <Form.Group as={Col} controlId="owner_person_id" >
                                    <Form.Label className="text-right"  sm={6} md={6} lg={1}>Contact</Form.Label>
                                 
                                        
                                            <Select
                                                isClearable
                                                value={this.state.selectedContact}
                                                onChange={this.handleContactChange}
                                                options={this.state.contactOptions}
                                                onCreateOption={this.handleCreateContactInputChange}
                                                onBlur={this.handleFormBlur}
                                            />
                                        
                                   
                                </Form.Group>
                                <Form.Group as={Col} controlId="contact_phone" >
                                    <Form.Label className="text-right" sm={6} md={6} lg={1}>Contact Phone</Form.Label>
                                    <Form.Control
                                        onChange={this.handleFormInputChange}
                                        value={this.state.contact_phone}
                                        as="input"
                                        type="text"
                                        onBlur={this.handleFormBlur}
                                        disabled
                                            readOnly
                                    />
                                </Form.Group>
                                
                                <Form.Group as={Col} controlId="contact_email" >
                                    <Form.Label className="text-right" sm={6} md={6} lg={1}>Contact Email</Form.Label>

                                    <Form.Control
                                        onChange={this.handleFormInputChange}
                                        value={this.state.contact_email}
                                        as="input"
                                        type="email"
                                        onBlur={this.handleFormBlur}
                                        disabled
                                        readOnly
                                    />


                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group as={Col} controlId="owner_person_id" >
                                    <Form.Label className="text-right"  sm={6} md={6} lg={1}>{this.props.sale_id? "Buyer/Vendor": "Lessee/Lessor"}</Form.Label>
                                 
                                        
                                            <Select
                                                isClearable
                                                value={this.state.selectedType}
                                                onChange={this.handleTypeChange}
                                                options={this.props.sale_id? this.state.typeOptions: this.state.leaseTypeOptions}                                                
                                                onBlur={this.handleFormBlur}
                                            />
                                        
                                   
                                </Form.Group>
                                <Col></Col>
                                <Col></Col>
                            </Row>
                            <Row>
                            <Col>
                            {this.state.owner_person_id && <Button type="button" onClick={this.addContactRecord} variant="primary" size="sm"> Add Another Contact</Button>}
                            
                            </Col>
                            </Row>
                            <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
                            

                        </Form>
                </Modal.Body>
                </Modal>
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={this.state.tableRows}
                    pageSize={data.length}
                    showPagination={this.state.tableRows>5?true:false }
                    sortable={false}
                />
                </div>
            )
        }

    }

    //Modify the attribute shown in the list for each type of record
    renderList(data) {
        return [{}].concat(data).map(
            (d, i) =>                
                i !== 0
                    ? 
                    <ListGroup.Item key={i} as="a" header={d.name}>
                        {d.name}                 
                    </ListGroup.Item>                
                    : ""
        );
    }



    
    renderComponent() {
        return (
            <div className="owners">
               
                 <Row className="show-Container">
                    <Col className="text-right" >
                    <a target="_blank" rel="noopener noreferrer" href={`/slmowners/new`}><Button variant="primary" type="button" size="sm" >Create New Owner</Button></a>{" "}
                        <Button variant="primary" size="sm" onClick={this.addRecord}>Add New Link</Button>

                    </Col>
                </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading ? this.props.controlType == "table2" ? this.renderTable2(this.props.data) : this.renderTable(this.props.data) : console.log("error")  }
                        </Col>
                    </Row>
               

            </div>
        );
    }
    render() {
        if (!this.props.data) {
            return null
        }
        else {
            return (

                <div className="OwnerLinkSection">
                    {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
                </div>
            );
        }
  }
}
